import { ENDPOINT } from '~/constants';

import { vestigasApi } from '~/services/kyClient';

import { type UnitsResponse, type UnitsSearchParams } from './types';
import { zodUnitsSearchParamsSchema } from './validations';

/**
 * Fetches all defined UN/CEFACT units from the API.
 * @param language - The language to fetch the units in.
 * @returns The mapped UN/CEFACT unit.
 * @throws Error if the API request fails.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Units/operation/get_complete_unit_mapping_dictionary_units_dictionary_get
 */
export const fetchUnits = async ({ language, unitType }: UnitsSearchParams) => {
  const response = await vestigasApi
    .get(ENDPOINT.UNITS.GET_ALL(), {
      searchParams: {
        language,
        unitType,
      },
      validate: { searchParams: zodUnitsSearchParamsSchema },
    })
    .json<UnitsResponse>();

  return response;
};
